export default "__VITE_ASSET__15ccf04b__"